var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#FF8049",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88 7.32C5.88 7.10133 5.91467 6.90933 5.984 6.744C6.05867 6.57867 6.14933 6.43733 6.256 6.32C6.36267 6.20267 6.50133 6.06933 6.672 5.92C6.90133 5.71733 7.06933 5.54133 7.176 5.392C7.288 5.23733 7.344 5.05067 7.344 4.832C7.344 4.53867 7.22933 4.304 7 4.128C6.77067 3.94667 6.456 3.856 6.056 3.856C5.39467 3.856 4.88533 4.072 4.528 4.504L4.104 4.184C4.55733 3.62933 5.22133 3.352 6.096 3.352C6.656 3.352 7.10133 3.47733 7.432 3.728C7.768 3.97867 7.936 4.31733 7.936 4.744C7.936 4.96267 7.89867 5.15733 7.824 5.328C7.75467 5.49333 7.66667 5.63467 7.56 5.752C7.45867 5.86933 7.32267 6.00533 7.152 6.16C6.92267 6.368 6.752 6.55467 6.64 6.72C6.528 6.88 6.472 7.08 6.472 7.32H5.88ZM6.176 9.04C6.05867 9.04 5.96 9 5.88 8.92C5.8 8.83467 5.76 8.736 5.76 8.624C5.76 8.50667 5.8 8.41067 5.88 8.336C5.96 8.256 6.05867 8.216 6.176 8.216C6.29867 8.216 6.4 8.256 6.48 8.336C6.56 8.41067 6.6 8.50667 6.6 8.624C6.6 8.736 6.55733 8.83467 6.472 8.92C6.392 9 6.29333 9.04 6.176 9.04Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltip_icon.2d8a2f5ffb249bb08e6475a97bba55b1.svg";
export { ForwardRef as ReactComponent };